import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Route, X } from "lucide-react";

const KEY = "a2g_path_nudge_last";

export function PathSwitchNudge({ currentDay }) {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!currentDay || currentDay < 3) return;
    const last = Number(localStorage.getItem(KEY) || 0);
    const days = (Date.now() - last) / 86400000;
    if (last === 0 || days >= 3) setShow(true);
  }, [currentDay]);

  const dismiss = () => {
    localStorage.setItem(KEY, String(Date.now()));
    setShow(false);
  };
  const go = () => {
    dismiss();
    navigate("/scegli");
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} className="mt-4 overflow-hidden">
          <div className="relative rounded-2xl border border-[#D4AF37]/30 bg-gradient-to-br from-[#18181C] to-[#0D0D0F] p-4" data-testid="path-switch-nudge">
            <button onClick={dismiss} data-testid="nudge-dismiss" className="absolute right-3 top-3 text-[#8A8E96]"><X size={16} /></button>
            <div className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#D4AF37]/12 text-[#D4AF37]"><Route size={17} /></span>
              <div className="flex-1 pr-5">
                <p className="text-lg text-[#F4F4F5] font-semibold">Questo percorso ti sta aiutando?</p>
                <p className="mt-1 text-sm leading-snug text-[#B4B4BC]">Se senti che non fa per te, puoi esplorare gli altri focus e cambiare quando vuoi.</p>
                <div className="mt-3 flex gap-2">
                  <button onClick={go} data-testid="nudge-explore" className="btn-outline-gold rounded-full px-4 py-2 text-sm">Esplora altri percorsi</button>
                  <button onClick={dismiss} data-testid="nudge-keep" className="rounded-full px-4 py-2 text-sm font-medium text-[#8A8E96]">Va bene così</button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
